// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import TasksCommentTextarea from './logic'

export default function TasksCommentTextareaFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/TasksCommentTextarea">
      <TasksCommentTextarea {...props}>
        {children}
      </TasksCommentTextarea>
    </Flow>
  )
}
